export default __webpack_public_path__ + "static/media/st.991910a7.svg";